// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/tax-compliance/tax-statement',
        component: () =>
            import('@/pages/[organisation]/tax-compliance/tax-statement.vue'),
        name: 'reports.tax-compliance.tax-statement',
        meta: {
            loginRequired: true,
            permission: 'access.reports.taxes.create-tax-statement',
        },
    },
    {
        path: '/:organisation/reports/taxes/sales-tax-return-summary',
        component: () =>
            import('@/pages/[organisation]/reports/taxes/sales-tax-return-summary.vue'),
        name: 'reports.taxes.sales-tax-return-summary',
        meta: {
            loginRequired: true,
            permission: 'access.reports.taxes.create-sales-tax-return-summary',
        },
    },
    {
        path: '/:organisation/reports/taxes/income-tax-summary',
        component: () =>
            import('@/pages/[organisation]/reports/taxes/income-tax-summary.vue'),
        name: 'reports.taxes.income-tax-summary',
        meta: {
            loginRequired: true,
            permission: 'access.reports.taxes.create-income-tax-summary',
        },
    },
];
